export default __webpack_public_path__ + "static/data-about-screenshot-3--mobile-1815600b4fa6733a5fea563b6ce79139.png";